/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   ใบส่งมอบ FG — หน้ารายการ
============================================================ */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card, Collapse, Form, Flex, Row, Col, Space, Select, Input, Button,
  Table, Typography, DatePicker, message,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import dayjs from "dayjs";

import { accessColumn, FH_STATUS } from "./model";
import useAccessPageState from "../../../hooks/useAccessPageState";
import FgHandoverService from "../../../service/ERP/FgHandover.service";

const fhService = FgHandoverService();
const { RangePicker } = DatePicker;

const FgHandoverAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [rows, setRows] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const run = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (data.fhdate?.length === 2) {
        data.fhdate_from = dayjs(data.fhdate[0]).format("YYYY-MM-DD");
        data.fhdate_to = dayjs(data.fhdate[1]).format("YYYY-MM-DD");
      }
      delete data.fhdate;
      fhService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => setRows(res.data?.data || []))
        .catch(() => message.error("Request error!"));
    };
    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      run(forcedValues);
      return;
    }
    form.validateFields().then(run);
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    handleSearch({}, restoreDefaultPagination());
  };

  const go = (action, r) =>
    navigate(`manage/${action}`, {
      state: {
        config: {
          action,
          code: r?.fhcode || null,
          title:
            action === "create"
              ? "สร้างใบส่งมอบ FG"
              : action === "edit"
              ? "แก้ไขใบส่งมอบ FG"
              : "ใบส่งมอบ FG",
        },
      },
    });

  const handleCancel = (r) =>
    fhService
      .cancel(r.fhcode)
      .then(() => {
        message.success("ยกเลิกใบส่งมอบแล้ว");
        handleSearch();
      })
      .catch((err) => message.error(err?.response?.data?.message || "ยกเลิกไม่สำเร็จ"));

  useEffect(() => {
    const restored = restoreState();
    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
  }, []);

  const FormSearch = (
    <Collapse
      size="small"
      bordered={false}
      activeKey={activeSearch}
      onChange={setActiveSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined /> <span>ค้นหา</span>
            </>
          ),
          children: (
            <Form form={form} layout="vertical" autoComplete="off">
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="เลขที่ใบส่งมอบ" name="fhcode">
                    <Input size="large" placeholder="FH..." allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="Production Order" name="pdcode">
                    <Input size="large" placeholder="PD..." allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="วันที่ส่งมอบ" name="fhdate">
                    <RangePicker size="large" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="สถานะ" name="doc_status">
                    <Select
                      size="large"
                      allowClear
                      placeholder="ทั้งหมด"
                      options={FH_STATUS.map((s) => ({ value: s, label: s }))}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Flex justify="end" gap={8}>
                <Button type="primary" size="small" className="bn-action" icon={<SearchOutlined />} onClick={() => handleSearch()}>
                  ค้นหา
                </Button>
                <Button type="primary" size="small" className="bn-action" danger icon={<ClearOutlined />} onClick={handleClear}>
                  ล้าง
                </Button>
              </Flex>
            </Form>
          ),
        },
      ]}
    />
  );

  return (
    <Space direction="vertical" size="middle" style={{ display: "flex" }}>
      {FormSearch}
      <Card>
        <Flex justify="space-between" align="center" className="mb-3">
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            ใบส่งมอบ FG
          </Typography.Title>
          <Button
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: "1.2rem" }} />}
            onClick={() => go("create")}
          >
            สร้างใบส่งมอบ
          </Button>
        </Flex>
        <Table
          size="small"
          rowKey="fhcode"
          columns={accessColumn({
            handleView: (r) => go("view", r),
            handleEdit: (r) => go("edit", r),
            handleCancel,
          })}
          dataSource={rows}
          scroll={{ x: "max-content" }}
          pagination={tablePagination}
          onChange={handleTableChange}
        />
      </Card>
    </Space>
  );
};

export default FgHandoverAccess;
